import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { Avatar } from 'src/game/components/shared/Avatar';
import i18n from 'src/lib/i18n/i18n';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { TeamExtendedProfile } from 'src/replicant/team/team.schema';

export class TeamFrame extends View {
  private readonly avatar: Avatar;
  private readonly team: LangBitmapFontTextView;
  private readonly label: LangBitmapFontTextView;

  constructor(opts: ViewOpts) {
    const [width, height] = [479, 157];
    super({ width, height, ...opts });

    new ImageScaleView({
      superview: this,
      image: 'assets/ui/match2/team/frames/frame_tc_create.png',
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 49, right: 49 },
        vertical: { top: 49, bottom: 49 },
      },
      width,
      height,
    });

    this.avatar = new Avatar({
      superview: this,
      width: 100,
      height: 100,
      centerOnOrigin: false,
    });

    this.avatar.updateOpts({
      offsetX: 30,
      offsetY: (height - 110) * 0.5,
    });

    this.label = new LangBitmapFontTextView({
      superview: this,
      x: 150,
      y: 20,
      align: 'left',
      verticalAlign: 'center',
      size: 25,
      font: 'Body',
      width: 316,
      height: 40,
      color: '#925F30',
      localeText: () => i18n('match2.team.leave_popup.currentTeam'),
    });

    this.team = new LangBitmapFontTextView({
      superview: this,
      x: 150,
      y: 58,
      align: 'left',
      verticalAlign: 'center',
      size: 35,
      font: 'Body',
      width: 316,
      height: 45,
      color: '#F24463',
      localeText: () => 'Unknown',
    });
  }

  public setup(team: TeamExtendedProfile, label: string) {
    this.avatar.updateImage(team.icon);
    this.team.localeText = () => team.name;
    this.label.localeText = () => label;
  }
}
